/**
 * Application main entry point.
 */
import App from "./App";
import { boot } from "./bootstrap";

boot(App);
